/**
 * Jalali (Shamsi) date formatting.
 *
 * prod1 hand-rolled the conversion in PaymentTable and got it wrong twice
 * over: its cumulative month table read [0,31,62,92,121,...] instead of
 * [0,31,62,93,124,...], drifting by up to six days and emitting impossible
 * dates like 1402/12/35; and it declared `jy` with const before doing
 * `jy +=`, throwing "Assignment to constant variable" for any date past day
 * 366 of the cycle -- which took the whole payments tab down with it.
 *
 * Every browser in this project's browserslist ships the persian calendar in
 * Intl, so we use it instead of re-deriving the arithmetic.
 */
let persianFormatter;
try {
  persianFormatter = new Intl.DateTimeFormat("fa-IR-u-ca-persian-nu-latn", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    timeZone: "Asia/Tehran",
  });
} catch {
  persianFormatter = null;
}

/** ISO date string -> "1403/5/22", or a placeholder when absent/invalid. */
export const formatJalali = (isoString, fallback = "----/--/--") => {
  if (!isoString) return fallback;

  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return fallback;

  // Without the persian calendar, show the ISO date rather than a wrong one.
  if (!persianFormatter) return date.toISOString().slice(0, 10);

  const parts = Object.fromEntries(
    persianFormatter.formatToParts(date).map((part) => [part.type, part.value])
  );
  return `${parts.year}/${parts.month}/${parts.day}`;
};
